import { Locale } from "common/locales/types";

export const getMomentLocale = (locale: Locale) => {
    if(locale === 'CZ') return 'cs';
    if(locale === 'EE') return 'es';

    return locale.toLowerCase();
}